/**
 * 购物车相关的API
 * 2021-12-21 14:24:57
 * @author SnowRock
 */

import request from '@/utils/request'

/**
 * 记录用户的点击行为埋点
 * 2026-07-02 13:00:00
 * @author SnowRock's uncle zhang
 * @param params
 * @param params.u_refer 当前网址
 * @param params.e_type 事件类型
 * @param params.e_data 事件内容
 * @returns {Promise<AxiosResponse<any>>}
 */
export function addUserDeed(params) {
  return request.post('/fontend/user/add-deed', params, {})
}
